import React from "react";
import DataTable from "react-data-table-component";

const DatatableMasterInstruments = (props) => {
  const columns = [
    {
      width: '20%',
      name: "Standard Akreditasi",
      selector: (row) => row?.elements_accreditation?.chapters_accreditation?.standards_accreditation.Nama,
    },
    {
      width: '10%',
      name: "Nomor",
      selector: (row) => row?.elements_accreditation?.Nomor,
    },
    {
      width: "8%",
      name: "Abjad",
      selector: (row) => row.Abjad,
    },
    {
      width: "30%",
      name: "Deskripsi",
      selector: (row) => row.Deskripsi,
      wrap: true,
    },
    {
      width: "21%",
      name: "Created At",
      selector: (row) => row.createdAt,
    },
    {
      width: "21%",
      name: "Updated At",
      selector: (row) => row.updatedAt,
    },
  ];

  return (
    <>
      <h5 className="card-title">Daftar Instrumen</h5>
      <DataTable
        columns={columns}
        data={props.datas}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Search"
            className="w-50 form-control m-3"
            values={props.search}
            onChange={(e) => props.handleChangeSearch(e.target.value)}
          />
        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatableMasterInstruments;
